var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgBorder2TopLeftMd = function SvgBorder2TopLeftMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 182,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 182V31C1 14.431 14.431 1 31 1h121",
    stroke: "#000"
  })));
};

export default SvgBorder2TopLeftMd;